/**
 * OneTrust global interface for cookie consent management.
 * OneTrust is loaded via Google Tag Manager.
 */
interface OneTrustGlobal {
  ToggleInfoDisplay: () => void
}

declare global {
  interface Window {
    OneTrust?: OneTrustGlobal
  }
}

/**
 * Toggles the OneTrust preference center display.
 * OneTrust is loaded via GTM and exposes a global function.
 * This is a no-op if OneTrust is not loaded.
 */
export const toggleOneTrustInfoDisplay = (): void => {
  globalThis.window?.OneTrust?.ToggleInfoDisplay()
}
